import { render, staticRenderFns } from "./avatars.vue?vue&type=template&id=f27ccf50"
import script from "./avatars.vue?vue&type=script&lang=js"
export * from "./avatars.vue?vue&type=script&lang=js"
import style0 from "./avatars.vue?vue&type=style&index=0&id=f27ccf50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports